module.exports = __webpack_public_path__ + "static/media/095-pitcairn-islands.588e0976.svg";